<template>

<div :class="[ 'single', { 'is-hidden': singleIsHidden }]">

    <single-header :project="project">

        <p>It explains what Artificial Intelligence is and where we can
        already use it for medical purposes, military operations, self-driving cars
        and research in outer space.
        The lovely robot drawings are made by the talented artist
        <a href="http://luniciasminion.deviantart.com/" target="_blank">Jennifer Koch</a>.</p>

    </single-header>

    <!-- SECTION -->

    <single-section info :color="project.color" header="1st Place in Digital Media Contest">

        <p>This project reached 1st place in a digital media contest organized by the
        parliament of Baden-Württemberg, South Germany in 2016 for educational purposes.</p>

    </single-section>

    <!-- SECTION -->

    <single-section header="Fun and Engaging">

        <p>The site targets children in elementary school to learn about robots.
        Therefore the texts are easy to understand with fun animations and
        a playful drawing for each topic to keep young readers interested.</p>

        <video src="assets/projects/robots-and-ai/transition.mp4" autoplay loop></video>

    </single-section>


</div>

</template>

<script>
import { singleHandler } from '@/modules/mixins'
export default {
    data() {
        return {
            project: {
                title: 'Robots and AI',
                subtitle: 'AI in our everyday lifes',
                background: '#f5f3f4 url(assets/projects/robots-and-ai/project-header.png) repeat center / contain !important',
                logoSuffix: 'png',
                color: '#5e5d5d',
                role: 'Informative',
                features: 'cute Drawings',
                url: 'https://robots.artofmyself.com'
            }
        }
    },
    mixins: [singleHandler]
}
</script>



// WEBPACK FOOTER //
// robots-and-ai.vue?0302a5ce